module.exports = __webpack_public_path__ + "img/危品WCA_01.57d89e61.png";